(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('orderLineCredit', {
        templateUrl: 'views/components/views/orderLineCredit/orderLineCredit.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'modalService', 'orderLineCreditService', 'logisticService', 'typeaheadService', 'translateService', function ($stateParams, stateService, utilityService, modalService, orderLineCreditService, logisticService, typeaheadService, translateService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let orderLineKeyno = $stateParams.orderline_keyno;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                orderButtons: [{ id: 'goto', icon: 'fa fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('orderhead', { order_internal_no: vm.model.edit.order_internal_no }) }],
                edit: {},
                selectListCauses: [],
                selectListStockPlaces: [],
                lockedSave: false,
                lockedApprove: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await orderLineCreditService.getOrderLineCredit({ orderline_keyno: orderLineKeyno }))[0];
            }

            async function loadCauses() {
                vm.model.selectListCauses = await orderLineCreditService.listOrderLineCreditCauses();
            }

            async function loadStocks() {
                if (utilityService.validateParmsValue(vm.model.edit.businessco_no, true) !== true) return;
                if (utilityService.validateParmsValue(vm.model.edit.businesssite_keyno, true) !== true) return;

                return vm.model.selectListStockPlaces = await logisticService.listStocks({
                    businessco_no: vm.model.edit.businessco_no,
                    businesssite_keyno: vm.model.edit.businesssite_keyno
                });
            }

            function retrieveStockPlace() {
                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_to, true) !== true) return;

                return logisticService.getStockPlace({ stockplace_id: vm.model.edit.stockplace_id_to }).then(function (response) {
                    vm.model.edit.floating_location = response[0].floating_location;
                });
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'stocklocation_name_to':
                        vm.model.edit[id] = value;

                        return typeaheadService.lookUpStockLocations({
                            stocklocation_name_search: vm.model.edit[id] || '',
                            stockplace_id: vm.model.edit.stockplace_id_to
                        });
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'stocklocation_name_to':
                        if (item) {
                            //vm.model.edit.stockplace_id_to = item?.item_id ?? '0';
                            vm.model.edit.stocklocation_keyno_to = item?.item_id ?? '0';
                            vm.model.edit.stocklocation_name_to = item?.item_name ?? '';
                        } else {
                            vm.onTypeaheadClear('stocklocation_name_to');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'stocklocation_name_to':
                        vm.model.edit.stocklocation_name_to = value;

                        if (value) {
                            if (item?.item_id) {
                                //vm.model.edit.stockplace_id_to = item.item_id;
                                vm.model.edit.stocklocation_keyno_to = item.item_id;
                            }
                        } else {
                            vm.onTypeaheadClear('stocklocation_name_to');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'stocklocation_name_to':
                        //vm.model.edit.stockplace_id_to = '0';
                        vm.model.edit.stocklocation_keyno_to = '0';
                        vm.model.edit.stocklocation_name_to = '';
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'stockplace_id_to':
                        if (utilityService.validateWatchValue(value, vm.model.edit.stockplace_id_to) !== true) return;

                        vm.model.edit.stockplace_id_to = value;

                        if (utilityService.validateParmsValue(vm.model.edit.stockplace_id_to, true) !== true) return;

                        retrieveStockPlace();
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

            // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                orderLineCreditService.saveObj(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	//stateService.back();		
                    }
                });
            }

            vm.approveChanges = function () {
                vm.model.lockedApprove = true;

                orderLineCreditService.approveObj(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: (dialogItself) => {
                                    dialogItself.close();
                                    vm.model.lockedApprove = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedApprove = false;
                        stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                await loadEdit();
                loadCauses();
                loadStocks();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
